import styled from 'styled-components';
import { m, p } from '@upgrade/react-components/Spacing/core';

export const Container = styled.div`
  background: ${({ theme, 'data-color': dataColor }) => theme.palette[dataColor]};
  ${p('md')};
  display: flex;

  @media (min-width: ${props => props.theme.mediaMd}) {
    border-radius: 0.5rem;
  }

  p {
    ${m('none')};
  }
`;
